<script setup lang="ts">
import { computed, ref } from 'vue'
import type { Testimonial } from '../data/content'

const props = withDefaults(defineProps<{ testimonials: Testimonial[]; lang?: 'pl' | 'en' }>(), { lang: 'pl' })
const activeIndex = ref(0)
const active = computed(() => props.testimonials[activeIndex.value]!)

const select = (index: number) => { activeIndex.value = index }
const previous = () => { activeIndex.value = (activeIndex.value - 1 + props.testimonials.length) % props.testimonials.length }
const next = () => { activeIndex.value = (activeIndex.value + 1) % props.testimonials.length }
</script>

<template>
  <div class="testimonial-slider" :aria-roledescription="lang === 'en' ? 'carousel' : 'karuzela'" :aria-label="lang === 'en' ? 'Participant reviews' : 'Opinie uczestników'">
    <div class="testimonial-stage" aria-live="polite">
      <p class="quote-mark" aria-hidden="true">“</p>
      <blockquote :key="active.author">
        <p>{{ active.quote }}</p>
        <footer>{{ active.author }}</footer>
      </blockquote>
    </div>

    <div class="slider-controls">
      <div class="slider-dots" role="tablist" :aria-label="lang === 'en' ? 'Select a review' : 'Wybierz opinię'">
        <button
          v-for="(testimonial, index) in testimonials"
          :key="testimonial.author"
          type="button"
          role="tab"
          :aria-selected="index === activeIndex"
          :aria-label="lang === 'en' ? `Show review: ${testimonial.author}` : `Pokaż opinię: ${testimonial.author}`"
          @click="select(index)"
        >
          0{{ index + 1 }}
        </button>
      </div>
      <div class="slider-arrows">
        <button type="button" :aria-label="lang === 'en' ? 'Previous review' : 'Poprzednia opinia'" @click="previous">←</button>
        <button type="button" :aria-label="lang === 'en' ? 'Next review' : 'Następna opinia'" @click="next">→</button>
      </div>
    </div>
  </div>
</template>
